import { useToast, Toast, ToastType } from '../context/ToastContext';
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const getToastStyles = (type: ToastType): string => {
    switch (type) {
      case 'success':
        return 'bg-green-500 dark:bg-green-600 text-white';
      case 'error':
        return 'bg-red-500 dark:bg-red-600 text-white';
      case 'warning':
        return 'bg-yellow-500 dark:bg-yellow-600 text-white';
      case 'info':
      default:
        return 'bg-blue-500 dark:bg-blue-600 text-white';
    }
  };

  const getToastIcon = (type: ToastType) => {
    const iconProps = { size: 20, className: "flex-shrink-0" };
    switch (type) {
      case 'success':
        return <CheckCircle {...iconProps} />;
      case 'error':
        return <AlertCircle {...iconProps} />;
      case 'warning':
        return <AlertTriangle {...iconProps} />;
      case 'info':
      default:
        return <Info {...iconProps} />;
    }
  };

  const renderToast = (toast: Toast) => (
    <div
      key={toast.id}
      className={`flex items-center gap-3 p-4 rounded-lg shadow-lg ${getToastStyles(toast.type)} min-w-[300px] max-w-[400px] animate-slide-in-right`}
    >
      {getToastIcon(toast.type)}
      <p className="flex-1 text-sm font-medium">{toast.message}</p>
      <button
        onClick={() => removeToast(toast.id)}
        className="flex-shrink-0 hover:opacity-80 transition-opacity"
        aria-label="Close notification"
      >
        <X size={18} />
      </button>
    </div>
  );

  if (toasts.length === 0) return null;

  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-2">
      {toasts.map(renderToast)}
    </div>
  );
};

export default ToastContainer;
